import {TextField, TextFieldProps} from "@mui/material";
import {Control, Controller, FieldValues, Path, useFormContext} from "react-hook-form";

type FormTextFieldProps<IFormValues extends FieldValues = FieldValues> =
    Omit<TextFieldProps, "name" | "value" | "error">
    & {
    name: Path<IFormValues>,
    control?: Control<IFormValues, any>
    readOnly?: boolean,
    handleChange?: Function,
    maxLength?: number,
    startAdornment?: any
}

const FormTextField = <IFormValues extends FieldValues = FieldValues>({
                                                                          name,
                                                                          control,
                                                                          readOnly,
                                                                          handleChange,
                                                                          maxLength,
                                                                          startAdornment,
                                                                          ...textFieldProps
                                                                      }: FormTextFieldProps<any>) => {
    // Use Form Context
    const formContext = useFormContext<IFormValues>();

    return (
        <Controller
            name={name}
            control={control ?? formContext.control}
            render={({field, fieldState, formState}) =>
                <TextField
                    {...textFieldProps}
                    ref={field.ref}
                    value={field.value === 0 ? field.value : field.value || ""}
                    fullWidth
                    onBlur={(e) => {
                        textFieldProps.onBlur?.(e);
                        field.onBlur();
                    }}
                    error={Boolean(fieldState.error)}
                    onChange={(e) => {
                        if (handleChange) {
                            handleChange(e.target.value);
                        } else {
                            field.onChange(e.target.value);
                        }
                    }}
                    disabled={readOnly ?? formState.isSubmitting}
                    helperText={fieldState.error?.message ?? textFieldProps.helperText}
                    InputProps={{
                        readOnly,
                        startAdornment: startAdornment
                    }}
                />
            }
        />
    );
};

export default FormTextField;
